
export default {
  computed: {
    multiPrinter () {
      return this.$page.props.brand === 'HANDY'
          && this.$store.state.majorAndroidVersion >= 3
    },
    canSendKitchenNotes () {
      return this.$page.props.brand === 'HANDY' && this.allDevicesUpTo('4.7')
    },
    canSendHandyActions () {
      return this.$page.props.brand === 'HANDY' && this.allDevicesUpTo('6.0.0') // TODO change to... 4.9.1 ???
    },
  },

  methods: {
    allDevicesUpTo (threshold) {
      threshold = threshold.versionize()
      if (threshold.length === 2) {
        threshold[2] = 0
      }

      const version = this.$page.props.deviceRange[0].versionize()

      for (let i = 0; i < 3; i++) {
        if (version[i] > threshold[i]) return true;
        if (version[i] < threshold[i]) return false;
      }
      return true;
    },
  },
}
